import { useLogoutApi } from "@entities/auth/api/logout-api";

export const useLogout = () => {
    const { logoutApi, loading } = useLogoutApi();

    const handleLogoutClick = () => {
        logoutApi();
    };

    return {
        handleLogoutClick,
        loading,
    };
};
